<template>
    <overlay-modal ref="overlayModal" width="65%">
        <template v-slot:header>
            <div class="d-flex justify-content-between">
                <h4 class="cursive">Scegli il giorno</h4>
                <div>
                    <button class="btn btn-primary" @click="onConfirm">Conferma modifiche</button>
                </div>
            </div>
        </template>
        <template>
            <div class="container">
                <div v-for="(index) in groups" :key="index" class="mb-3">
                    <h3>{{'Camera ' + (index+1)}}</h3>
                    <div class="bg-light py-3 px-4">
                        <div class="bg-light row">
                            <div v-for="(item, index2) in days" :key="index2" class="col-4">
                                <div class="my-2">
                                    <button :class="classes(index, item.day)" @click="onChange(index, item.day)">
                                        {{longDateFormatter(item.day)}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import OverlayModal from '../../../modals/OverlayModal'
import {longDateFormatter} from '../../../../utils/formatter'
import {isSameDate, clone} from '../../../../utils/helper'

export default {
  name: 'ModalServiceChangeDate',
  components: {OverlayModal},
  data () {
    return {
      groups: this.groups
    }
  },
  computed: {
    days () {
      return this.getItinerario().days
    }
  },
  methods: {
    ...mapGetters(['getItinerario']),
    ...mapActions(['addReplaceServizio', 'removeSelectedServizio']),
    longDateFormatter,
    open (groups) {
      this.groups = clone(groups)
      this.$refs.overlayModal.open()
    },
    close () {
      this.$refs.overlayModal.close()
    },
    isSelectedDay (index, day) {
      return isSameDate(day, this.groups[index].dateSelected)
    },
    classes (index, day) {
      const isSelected = this.isSelectedDay(index, day)
      return `pointer w-100 btn rounded-0 text-uppercase cursive ${isSelected ? 'btn-primary' : 'btn-outline-primary'}`
    },
    isSelectedGroup (index) {
      return this.groups[index].dateSelected != null
    },
    onChange (index, day) {
      if (!isSameDate(day, this.groups[index].dateSelected)) {
        this.groups[index].dateSelected = day
      }
    },
    onConfirm () {
      this.$emit('change', this.groups)
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalServiceChangeDate.vue